import { Link as RouterLink } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Link from "@mui/material/Link";
import PackageGroupsView from "~/components/packageGroups/PackageGroupsView";
import { useFeatures } from "~/hooks/useFeatures";

export default function Packages() {
  const { loading, features } = useFeatures();
  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <CircularProgress aria-label="Carregando" />
      </Box>
    );
  }
  if (!features.mergeManual) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">
          A tela “Pacotes em grupos” está desligada no momento. Use{" "}
          <Link component={RouterLink} to="/admin/antecipe/solicitacoes">Antecipações</Link>.
        </Alert>
      </Box>
    );
  }
  return <PackageGroupsView />;
}
